import { Input } from "antd";
import React, { useEffect, useRef } from "react";

import { getLocationFromPlace, getMapApi, parseAddressComponents } from "../../utils/googleMap";

function PlacesAutoComplete(props) {
  const { defaultValue, onChange, value, refresh } = props;
  const searchInput = useRef(null);

  useEffect(() => {
    let autoComplete = null;

    const initAutoSearch = async () => {
      const mapApi = await getMapApi();
      /* @ts-expect-error FIXME this wrong type */
      const { input } = searchInput.current;
      autoComplete = new mapApi.places.Autocomplete(input);
      /* @ts-expect-error FIXME this wrong type */
      autoComplete.addListener("place_changed", onPlaceChanged);

      input.focus();
    };

    const onPlaceChanged = () => {
      /* @ts-expect-error FIXME this wrong type */
      const place = autoComplete.getPlace();

      if (!place.geometry) {
        return;
      }

      const location = getLocationFromPlace(place);
      const address = parseAddressComponents(place.address_components);

      address.formatted = place.formatted_address;
      onChange({ location, address });
    };

    void initAutoSearch();
  }, [onChange]);

  useEffect(() => {
    /* @ts-expect-error FIXME this wrong type */
    searchInput.current?.input.focus();
  }, [refresh]);

  const onInputChange = (e) => {
    const { value: val } = e.target;
    if (!val || val.length === 0) {
      onChange(null);
    }
  };

  return (
    <Input
      placeholder="Search for area, street name..."
      ref={searchInput}
      allowClear
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      value={value}
      style={{ maxWidth: "400px" }}
      defaultValue={defaultValue}
      onChange={onInputChange}
    />
  );
}

export { PlacesAutoComplete };
